import { useQuery } from '@tanstack/react-query'
import { usersAPI } from '../services/api'

export const useUsers = ({ search = '', filters = {}, page = 1, limit = 25 } = {}) => {
  return useQuery({
    queryKey: ['admin', 'users', { search, filters, page, limit }],
    queryFn: async () => {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
      })

      if (search.trim()) {
        params.append('search', search.trim())
      }

      // Status filter
      if (filters.status && filters.status !== 'all') {
        params.append('status', filters.status)
      }

      // Credit range filter
      if (filters.creditRange && Array.isArray(filters.creditRange)) {
        if (filters.creditRange[0] !== 0) {
          params.append('creditMin', filters.creditRange[0].toString())
        }
        if (filters.creditRange[1] !== 1000) {
          params.append('creditMax', filters.creditRange[1].toString())
        }
      }

      // Date range filter
      if (filters.dateRange) {
        if (filters.dateRange.startDate) {
          params.append('dateFrom', filters.dateRange.startDate.toISOString().split('T')[0])
        }
        if (filters.dateRange.endDate) {
          params.append('dateTo', filters.dateRange.endDate.toISOString().split('T')[0])
        }
      }

      // Sorting
      if (filters.sortBy) {
        params.append('sortBy', filters.sortBy)
      }
      if (filters.sortOrder) {
        params.append('sortOrder', filters.sortOrder)
      }

      const response = await usersAPI.getUsers(Object.fromEntries(params))
      return response.data.data
    },
    staleTime: 30000, // 30 seconds
    refetchOnWindowFocus: false,
  })
}

export const useUserStats = () => {
  return useQuery({
    queryKey: ['admin', 'users', 'stats'],
    queryFn: async () => {
      const response = await usersAPI.getUsers({ page: 1, limit: 1 })
      return response.data.data.stats
    },
    staleTime: 60000, // 1 minute
    refetchOnWindowFocus: false,
  })
}